import { boot } from 'quasar/wrappers'
import * as Sentry from '@sentry/vue'

export default boot(async ({ Vue }) => {
  Sentry.init({
    release: process.env.RELEASE,
    dsn: process.env.SENTRY_DSN,
    trackComponents: true,
    beforeSend (event) {
      event.tags = event.tags || {}

      if (Vue.auth.check()) {
        const { id, name: username } = Vue.auth.user()
        event.user = { id, username }
      }

      return event
    }
  })
})
